import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
	eventRelation,
	eventVerify,
	redirectToPlay,
	refreshAuthToken,
} from "../redux/event";
import { useDispatch } from "react-redux";
import { getCookie } from "../utils/Cookies";
import { useSelector } from "react-redux";

interface IProps {
	children?: any;
}

export const RouteInterceptor = ({ children }: IProps) => {
	const navigate = useNavigate();

	const eventCode = getCookie("eventCode");
	const dispatch = useDispatch<any>();
	const accessToken = getCookie("accessToken");
	const refreshToken = getCookie("refreshToken");

	const windowUrl = window.location.search;
	const params = new URLSearchParams(windowUrl);
	const queryStringEventCode = params.get("eventCode");

	const event: any = useSelector((state: any) => state.event);

	const getEventRelationAndNavigate = async () => {
		const data = await dispatch(eventRelation({ eventCode }));
		if (
			data?.payload?.status === "success" ||
			["tradeshow", "raffle"].includes(event?.eventVerfiyData?.distinctName)
		)
			dispatch(redirectToPlay(eventCode));
		else if (
			data.payload.message === "SECRET CODE REQUIRED" &&
			window.location.pathname !== "/verify-guest"
		)
			navigate("/verify-guest");
	};

	React.useEffect(() => {
		if (!accessToken && refreshToken) {
			(async () => {
				const res = await dispatch(
					refreshAuthToken({ refreshToken: refreshToken })
				);
				if (res?.payload?.status === "success")
					await getEventRelationAndNavigate();
			})();
		} else if (accessToken && eventCode) {
			(async () => {
				await getEventRelationAndNavigate();
			})();
		}
	}, []);

	React.useEffect(() => {
		(async () => {
			if (queryStringEventCode) {
				await dispatch(eventVerify({ eventCode: queryStringEventCode }));
			} else if (!eventCode) {
				// navigate('/event'); // ? removed navigate('/event') due to issue in prod of random redirection to homepage
			} else {
				const res = await dispatch(eventVerify({ eventCode }));
				if (res?.payload?.data?.distinctName === "raffle") {
					dispatch(redirectToPlay(eventCode));
				}
			}
		})();
	}, [eventCode, dispatch, queryStringEventCode, navigate]);

	return <div>{children}</div>;
};
